/* eslint-disable react/display-name */
import React from 'react'
import { getMostRecentOrder } from '../../utils'

const reducedImages = (items, size) => {
  const reducedImagesFormatted = items.map((item) => ({
    alt: item?.title,
    src: item?.media?.find((media) => media.type === 'mood-image').urls[size]?.src,
  }))

  return reducedImagesFormatted
}

const withMostRecentOrder = (Component) => (props) => {
  const { orders } = props
  const mostRecentOrder = getMostRecentOrder(orders)
  let mostRecentOrderReduced = null

  if (mostRecentOrder) {
    const {
      id,
      human_delivery_date: deliveryDate,
      prices,
      phase,
      recipe_items: recipeItems,
    } = mostRecentOrder

    mostRecentOrderReduced = {
      id,
      deliveryDate,
      price: prices?.total,
      state: phase,
      images: reducedImages(recipeItems, 2),
    }
  }

  return (
    <Component
      order={mostRecentOrderReduced}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  )
}

export { withMostRecentOrder }
